import {
  LOADING_EVENTS,
  SET_DETAILED_EVENT,
  SET_IS_SUPERCHARGED_BET_TICKER_VISIBLE,
  SET_LAST_SEEN_SPORT_PAGE,
  SET_RACE,
  SET_TRIGGER_SPORRTSBOOK_RESUBSCRIPTIONS,
  SportsbookActionType,
  SportsbookState,
} from '../types/sportsbookTypes';
import { RESET_STATE } from '../types/stateTypes';

export const initialSportsbookState: SportsbookState = {
  detailedEvent: undefined,
  race: undefined,
  loadingEvents: false,
  isSuperchargedTickerVisible: false,
  triggerSportsbookResubscriptions: false,
  lastSeenSportPage: undefined,
};

export const sportsbookReducer = (state = initialSportsbookState, action: SportsbookActionType): SportsbookState => {
  switch (action.type) {
    case RESET_STATE:
      return {
        ...initialSportsbookState,
        detailedEvent: state.detailedEvent ? { ...state.detailedEvent } : undefined,
        race: state.race ? { ...state.race } : undefined,
      };
    case SET_DETAILED_EVENT: {
      return { ...state, detailedEvent: action.meta };
    }
    case SET_RACE: {
      return { ...state, race: action.meta };
    }
    case LOADING_EVENTS: {
      return { ...state, loadingEvents: action.meta };
    }
    case SET_IS_SUPERCHARGED_BET_TICKER_VISIBLE: {
      return { ...state, isSuperchargedTickerVisible: action.meta };
    }
    case SET_TRIGGER_SPORRTSBOOK_RESUBSCRIPTIONS: {
      return { ...state, triggerSportsbookResubscriptions: action.meta };
    }
    case SET_LAST_SEEN_SPORT_PAGE: {
      return { ...state, lastSeenSportPage: action.meta };
    }
    default:
      return state;
  }
};
